<!--
 * @Author: mengxiangfa
 * @Date: 2021-05-21 10:37:59
 * @LastEditors: mengxiangfa
 * @LastEditTime: 2021-06-09 13:25:17
 * @Description: file content
 * @FilePath: \DDDgClient\src\views\switch\record.vue
-->
<template>
  <div class="record-box">
    <navbar title="开关更换记录"> </navbar>
    <div class="search">
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        placeholder="选择位置"
        @click="selectLoactionShow = true"
      />
    </div>
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        offset="30"
        @load="onLoad"
      >
        <template #loading>
          <van-overlay
            :show="loadingShow"
            z-index="1999"
            class-name="loading-overlay"
          >
            <div class="wrapper">
              <div class="block">
                <van-loading />
              </div>
            </div>
          </van-overlay>
        </template>
        <record-item :type="2" :lables="lables" :data="recordList" />
      </van-list>
    </div>
    <my-cascader
      :type="2"
      :status.sync="selectLoactionShow"
      :loacTree="searchArr"
      @serach="serach"
    />
  </div>
</template>

<script>
import "../../style/style.scss"
import navbar from "../../components/Navbar"
import recordItem from "../../components/RecordItem"
import myCascader from "../../components/MyCascader"
import { getLocationTree, getBreakerChangeList } from "../../request/api"

export default {
  name: "switchRecord",
  components: {
    navbar,
    recordItem,
    myCascader,
  },
  data() {
    return {
      loading: false,
      finished: false,
      loadingShow: false,
      newToast: "",
      query: {
        projectId: "",
        id: "",
        row: "",
        column: "",
        page: 1,
        pageSize: 10,
      },
      lables: [
        {
          lable: "开关位置",
          key: "",
        },
        {
          lable: "更换时间",
          key: "changeTime",
        },
        {
          lable: "更换原因",
          key: "changeReason",
        },
        {
          lable: "开关状态",
          key: "breakerStatus",
        },
      ],
      recordList: [],
      searchArr: [],
      selectLoactionShow: false,
      fieldValue: "",
    }
  },
  created() {
    this.query.projectId = this.$route.query.projectId
    this.getTree()
  },
  methods: {
    onLoad() {
      this.getList()
      this.query.page++
    },
    getList() {
      this.loadingShow = true
      getBreakerChangeList(this.query)
        .then(res => {
          let arr = res.data.items
          if (arr.length === 0) {
            this.loadingShow = false
            this.finished = true
          } else {
            this.recordList.push(...arr)
            this.loadingShow = false
          }
        })
        .catch(err => {
          this.loadingShow = false
        })
    },
    getTree() {
      getLocationTree({ projectId: this.query.projectId })
        .then(res => {
          this.searchArr = res.data.towerList
        })
        .catch(err => {
          console.log(err)
        })
    },
    serach($e) {
      let arr = $e
      this.fieldValue = arr.map(option => option.name).join("/")
      if (arr[arr.length - 1].tag === 4) {
        this.query.id = arr[arr.length - 2].id
        this.query.row = arr[arr.length - 1].id
        this.query.column = ""
      } else if (arr[arr.length - 1].tag === 5) {
        this.query.id = arr[arr.length - 3].id
        this.query.row = arr[arr.length - 2].id
        this.query.column = arr[arr.length - 1].id
      } else {
        this.query.id = arr[arr.length - 1].id
        this.query.row = ""
        this.query.column = ""
      }
      this.finished = false
      this.query.page = 1
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.record-box {
  padding-top: 90px;

  .search {
    margin: 30px 55px;
    width: 640px;
    height: 70px;
    border-radius: 35px;
    background: #fff;
    border: 2px solid #eaeaea;
    ::v-deep .van-cell {
      padding: 0 37px;
      line-height: 70px;
      background-color: unset;
      .van-field__control {
        font-size: 24px;
      }

      .van-cell__right-icon {
        height: 70px;
        line-height: 70px;
        font-size: 28px;
        color: #333;
      }
    }
  }
  .list {
    position: relative;
    overflow: scroll;
    // padding: 0 55px;
    width: 100%;
    height: calc(100vh - 220px);
    // overflow-y: auto;
  }
}
.loading-overlay {
  background-color: rgba(0, 0, 0, 0);
}
</style>
